import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getCargos: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].GET_CARGOS,
	},
	getCargo: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO,
	},
	createCargo: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].CREATE_CARGO,
	},
	putCargo: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].PUT_CARGO,
	},
	patchCargo: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].PATCH_CARGO,
	},
	deleteCargo: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].DELETE_CARGO,
	},
	getCargoPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_PREVIEW,
	},
	getCargoPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_POPUP,
	},
}
